import script from "./resetPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./resetPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./resetPasswordPage.vue?vue&type=style&index=0&id=02e3868e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02e3868e"]])

export default __exports__